import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownItem, HelpTip } from '@amzn/storm-ui';
import { FormRow } from '@amzn/storm-ui-column-form-kit';
import {
  PRIVILEGED_MODE_OPTIONS,
  PrivilegedModeValue,
} from '../../constants/userTableConstants';
import { TooltipContent } from './PrivilegedModeDropDown.styles';

const PrivilegedModeDropDown = ({
  privilegedMode,
  setPrivilegedMode,
}: {
  privilegedMode: boolean;
  setPrivilegedMode: (value: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <FormRow
      id="privileged-mode"
      label={
        <>
          {t('privileged-mode-label')}{' '}
          <HelpTip>
            <TooltipContent>{t('privileged-mode-tooltip')}</TooltipContent>
          </HelpTip>
        </>
      }
      controlComponents={[
        (componentId) => (
          <Dropdown
            id={componentId}
            selectedValue={
              privilegedMode ? PrivilegedModeValue.ON : PrivilegedModeValue.OFF
            }
            onChange={(value: string) =>
              setPrivilegedMode(value === PrivilegedModeValue.ON)
            }
          >
            {PRIVILEGED_MODE_OPTIONS.map(({ value, labelKey }) => (
              <DropdownItem
                id={`dropdown-item-privileged-${value}`}
                key={value}
                value={value}
              >
                {t(labelKey)}
              </DropdownItem>
            ))}
          </Dropdown>
        ),
      ]}
    />
  );
};

export default PrivilegedModeDropDown;
